import {
  Box,
  Flex,
  IconButton,
  Text,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  useDisclosure,
} from "@chakra-ui/react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { selectUser } from "@/reducer/userslice";
import { RiEqualizer2Line } from "@remixicon/react";
import PictureControlModal from "./picturecontrolmodal";
import { selectMode, updateDesign } from "@/reducer/modeslice";

const SmrPictureControl = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser);
  const { design } = useAppSelector(selectMode);
  const pictureControl = useDisclosure();

  const handleChangePicControlStrength = (value: number) => {
    let currentStructureImages = [...design.refstructure];
    currentStructureImages[0] = {
      ...currentStructureImages[0],
      weight: value / 100,
    };
    const newdesign = { ...design, refstructure: currentStructureImages };
    dispatch(updateDesign(newdesign));
  };

  const handleOpenPicControlModal = () => {
    pictureControl.onOpen();
  };

  return (
    <Box mt="20px">
      <Box fontSize={"14px"} color="#FFFFFF" mb="10px">
        图片控制
      </Box>
      <Box
        background="linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)"
        borderRadius="10px"
        p="1px"
      >
        <Box background="#0C0B10" p="15px" borderRadius="10px">
          <Flex alignItems={"center"} gap="20px">
            <Box flex={1}>
              {design.refstructure[design.refstructure.length-1].refStructureType === "lineart" && (
                <Box>
                  <Box mb="12px" fontSize={"14px"} color="#FFFFFF">
                    景深控制：提取空间形状
                  </Box>
                  <Flex alignItems={"center"} gap="12px">
                    <Text fontSize={"14px"} color="#6C7596">
                      控制强度
                    </Text>
                    <Slider
                      flex={1}
                      value={Math.floor(design.refstructure[design.refstructure.length-1].weight * 100)}
                      step={1}
                      min={1}
                      max={100}
                      onChange={handleChangePicControlStrength}
                    >
                      <SliderTrack bg="#6C7596" h="8px" borderRadius={"8px"}>
                        <SliderFilledTrack bg="linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)" />
                      </SliderTrack>
                      <SliderThumb bg="#FFFFFF" boxSize={"18px"} />
                    </Slider>
                    <Text fontSize={"14px"} color="#FFFFFF">
                      {Math.floor(design.refstructure[design.refstructure.length-1].weight * 100)}%
                    </Text>
                  </Flex>
                </Box>
              )}
              {design.refstructure[design.refstructure.length-1].refStructureType === "mlsd" && (
                <Box>
                  <Box fontSize={"14px"} color="#FFFFFF">
                    线条控制：提取图片线条轮廓后出图
                  </Box>
                </Box>
              )}
            </Box>

            <IconButton
              variant="unstyled"
              aria-label="picturecontrol"
              fontSize="16px"
              w="24px"
              minW={"24px"}
              h="24px"
              color="#6C7596"
              _hover={{
                color: "#ffffff",
              }}
              icon={<RiEqualizer2Line size={"24px"} />}
              onClick={handleOpenPicControlModal}
            />
          </Flex>

          {/* {smrDesign.picturecontrol === "重绘原图内容" && (
            <Flex alignItems={"center"} gap="20px">
            <Box flex={1}>
              <Box fontSize={"16px"} color="#FFFFFF">
                重绘原图内容
              </Box>
            </Box>
            <IconButton
              variant="unstyled"
              aria-label="picturecontrol"
              fontSize="16px"
              w="24px"
              minW={"24px"}
              h="24px"
              color="#6C7596"
              _hover={{
                color: "#ffffff",
              }}
              icon={<RiEqualizer2Line size={"24px"} />}
              onClick={handleOpenPicControlModal}
            />
          </Flex>
          )} */}
        </Box>
      </Box>
      <PictureControlModal
        isOpen={pictureControl.isOpen}
        onClose={pictureControl.onClose}
      />
    </Box>
  );
};

export default SmrPictureControl;
